var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_vm._v("\n    Statistics\n\n    "),_c('page-views'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('visitors')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }